import type { AxiosInstance, AxiosRequestConfig } from 'axios';
import axios from 'axios';

export const createInstance = (config: AxiosRequestConfig): AxiosInstance =>
  axios.create(config);
